export default __webpack_public_path__ + "static/media/g.90504be3.mp4";